import { CordovaPluginsService } from './cordova-plugins.service.abstract';
import { BehaviorSubject } from 'rxjs';

export class NoopCordovaPluginsService extends CordovaPluginsService {
  constructor() {
    super();
  }

  browsertab = null;
  device = null;
  deviceInfo = {};
  Keyboard = null;
  PushNotification = null;
  QRScanner = null;
  SafariViewController = null;
  SecureStorage = null;
  isSecureStorageAvailable = false;
  notification = null;
  SocialSharing = null;
  SplashScreen = null;
  StatusBar = null;
  universalLinks = null;
  appAvailability = null;

  isSafariViewControllerAvailable = new BehaviorSubject<boolean>(false);
  checkIfSafariViewControllerPluginIsAvailable() {}

  deleteFromSecureStorage(id: string) {
    return Promise.reject();
  }

  readFromSecureStorage(id: string) {
    return Promise.reject();
  }

  writeToSecureStorage(id: string, data: string) {
    return Promise.reject();
  }

  initSecureStorage() {
    return Promise.reject();
  }

  isAndroid() {
    return false;
  }

  openUrl(url: string): void {
    window.open(url, '_blank', 'location=no');
  }

  shareNativeVia(packageName: string, methodName: string, url: string, message?: string): Promise<boolean> {
    return Promise.reject(false);
  }
  canShareVia(packageName: string, url: string, message?: string): Promise<boolean> {
    return Promise.reject(false);
  }
}
